<template>
	<div class="btn_edit">
		<div class="btn_Expo_file">
			<b-button variant="light" @click="downloadCSV"><b-icon icon="file-earmark-arrow-down"></b-icon>
				{{ fileType == "Excel" ? "Export to Excel" : "Export File" }}</b-button>
		</div>
		<div class="btn_Impo_file" v-if="importFile">
			<tera-file-select :title="'Choose a file to import...'" placeholder="Choose a file to import..."
				@change="fileInputEvent($event)" />
			<b-button @click="readFile" squared><b-icon icon="inbox-fill"></b-icon> Import</b-button>
		</div>
	</div>
</template>
<script>
import TeraFileSelect from "@iebh/tera-fy/widgets/tera-file-select.vue";
import { BButton, BIcon } from "bootstrap-vue";
import ExcelJS from "exceljs";
export default {
	name: "fileOptions",
	components: {
		TeraFileSelect,
		BButton,
		BIcon
	},
	props: {
		gridApi: null,
		importFile: Boolean,
		fileType: {
			type: String,
			default: ""
		}
	},
	data() {
		return {
			file: null,
			hasUndefined: false
		};
	},
	computed: {
		ifImport() {
			return this.file != null;
		}
	},
	methods: {
		fileInputEvent(file) {
			this.file = file;
		},
		//Import Xlsx File
		readFile() {
			//TODO Import File in Extraciton Table
		},
		// Export CSV File
		downloadCSV() {
			this.$prompt("New File Name:", "Download CSV File", {
				confirmButtonText: "Download",
				cancelButtonText: "Cancel"
			})
				.then(filename => {
					console.log("Here the download happens", filename);
					if (this.fileType == "Excel") {
						console.log("Here the download happens", filename);
						this.exportDataExTable(filename);
					} else {
						this.exportPlanTable(filename);
					}
					this.hasUndefined ? this.$message({
						type: "info",
						message: "Empty table or Undefined values in the table"
					}) : this.$message({
						type: "success",
						message: "Download Successfully!"
					});
				})
				.catch(() => {
					this.$message({
						type: "info",
						message: "Cancel downloading file"
					});
				});
		},
		//PlanTable: Export CSV File
		exportPlanTable(filename) {
			this.gridApi.csvCreator.exportDataAsCsv({
				processCellCallback: params => {
					if (params.column.colId == "toolLink") {
						return params.value.map(el => {
							return el.name;
						});
					}
					if (params.column.colId == "peopleInvolved") {
						if (params.value != "") {
							return params.value.map(el => {
								return el.label;
							});
						}
					}
					return params.value;
				},
				fileName: filename.value
			});
		},
		async exportDataExTable(filename) {
			const workbook = new ExcelJS.Workbook();
			const worksheet = workbook.addWorksheet("Plan Table");

			// Get grid columns and headers
			const columns = this.gridApi.getColumnDefs();
			const headers = columns.map(col => col.headerName);

			// Checking for empty table headers
			this.hasUndefined = headers.some(value => value === undefined) || headers.length == 0;
			if (this.hasUndefined) return;

			// Add headers to the worksheet
			worksheet.addRow(headers).font = { bold: true };

			// Initialize column widths
			const columnWidths = headers.map(header => header.length);

			// Get all row data
			const allRowData = [];
			this.gridApi.forEachNode(node => {
				allRowData.push(node.data);
			});

			// Add data rows to the worksheet
			allRowData.forEach(row => {
				const rowData = columns.map(col => {
					return row[col.field] || "";
				});

				worksheet.addRow(rowData);

				// Update column widths
				rowData.forEach((cellData, colIndex) => {
					const cellDataLength = String(cellData).length;
					if (cellDataLength > columnWidths[colIndex]) {
						columnWidths[colIndex] = cellDataLength;
					}
				});
			});

			// Set column widths
			headers.forEach((_, index) => {
				worksheet.getColumn(index + 1).width = Math.max(
					10,
					columnWidths[index] + 2
				);
			});

			// Apply alternating colors to header row
			headers.forEach((_, index) => {
				const isEvenColumn = index % 2 === 0;
				const cell = worksheet.getCell(1, index + 1);
				if (isEvenColumn) {
					cell.fill = {
						type: "pattern",
						pattern: "solid",
						fgColor: { argb: "fceddd" }
					};
				} else {
					cell.fill = {
						type: "pattern",
						pattern: "solid",
						fgColor: { argb: "f6c897" }
					};
				}
			});

			// Write the workbook and trigger download
			const buffer = await workbook.xlsx.writeBuffer();
			const blob = new Blob([buffer], {
				type:
					"application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
			});

			const link = document.createElement("a");
			link.href = URL.createObjectURL(blob);
			link.download = filename.value
				? `${filename.value}.xlsx`
				: "DataExtraction.xlsx";
			link.click();
		}
	}
};
</script>
<style scoped>
.btn_edit {
	display: flex;
	justify-content: flex-start;
}

.btn_Impo_file {
	display: flex;
	justify-content: flex-start;
}

.btn_Expo_file {
	position: relative;
	top: 40%;
}

.tera-library-select {
	min-height: 35px !important;
	height: 35px;
	width: 200px !important;
	position: relative;
	top: 40%;
}

.btn-secondary {
	position: relative;
	top: 40%;
	height: 35px;
}

.btn {
	--bs-btn-font-size: 0.8rem;
}
</style>
